module.exports = __webpack_public_path__ + "img/open_in_new.a41d9ceb.svg";